import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SidebarModule } from 'primeng/sidebar';
import { CapturumSidebarComponent } from './sidebar.component';

@NgModule({
  imports: [SidebarModule, CommonModule, CapturumSidebarComponent],
  exports: [CapturumSidebarComponent],
})
export class CapturumSidebarModule {}
